import {format} from 'date-fns/format';
import {isSameDay} from 'date-fns/isSameDay';
import {isValid as isValidDate} from 'date-fns/isValid';
import isObject from 'lodash/isObject';

import {formatDate} from '@edna/utils';

import {DATE_FORMAT, EMPTY_DATE_FORMAT, TOption, TValue, VALID_PERIOD_SET} from './types';

const renderRangeValue = (value: TValue) => {
  const payloadSettings = {
    format: DATE_FORMAT,
    formatter: format,
  };

  const startDateFormat = value.startDate
    ? formatDate(value.startDate, payloadSettings)
    : EMPTY_DATE_FORMAT;
  const stopDateFormat = value.stopDate
    ? formatDate(value.stopDate, payloadSettings)
    : EMPTY_DATE_FORMAT;

  if (startDateFormat === stopDateFormat) {
    return startDateFormat;
  }

  return `${startDateFormat} - ${stopDateFormat}`;
};

const getValue = (value: any): TValue => {
  const period = value?.period as TValue['period'];
  const startDate = (value?.startDate ?? null) as TValue['startDate'];
  const stopDate = (value?.stopDate ?? null) as TValue['stopDate'];

  const isValidStartDate = isValidDate(startDate);
  const isValidStopDate = isValidDate(stopDate);

  if (!VALID_PERIOD_SET.has(period) && isValidStartDate && isValidStopDate) {
    return {period, startDate, stopDate};
  }

  if (
    VALID_PERIOD_SET.has(period) &&
    period !== 'anytime' &&
    (isValidStartDate || isValidStopDate)
  ) {
    return {
      period,
      startDate: isValidStartDate ? startDate : null,
      stopDate: isValidStopDate ? stopDate : null,
    };
  }

  return {
    period: 'anytime',
    startDate: null,
    stopDate: null,
  };
};

const compareOptionWithValue = ({value: optionValue}: TOption, value: TValue) => {
  if (isObject(optionValue)) {
    if (!optionValue.startDate || !optionValue.stopDate || !value.startDate || !value.stopDate) {
      return false;
    }

    return (
      isSameDay(optionValue.startDate, value.startDate) &&
      isSameDay(optionValue.stopDate, value.stopDate)
    );
  }

  return optionValue === value.period;
};

export {getValue, renderRangeValue, compareOptionWithValue};
